<template>
  <div class="paySuccess">
    <div class="textBox">
      <van-icon class="icon" name="checked" />
      <p>支付成功</p>
    </div>
    <van-button @click="close" class="closeBtn">关闭</van-button>
  </div>
</template>

<script>
import { Icon, Button } from 'vant';
export default {
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button
  },
  data() {
    return {

    };
  },
  computed: {

  },
  created() {

  },
  mounted() {

  },
  watch: {

  },
  methods: {
    close() {
      window.AlipayJSBridge.call('closeWebview');
    }
  },
};
</script>

<style lang="scss" scoped>
.paySuccess {
  overflow: hidden;
  position: relative;
  .textBox {
    text-align: center;
    margin: 50px auto;
    .icon {
      font-size: 60px;
      color: #008de3;
    }
    p {
      margin-top: 20px;
      font-size: 26px;
    }
  }
  .closeBtn {
    width: 100px;
    position: fixed;
    left: 50%;
    bottom: 100px;
    margin-left: -50px;
  }
}
</style>
